import React from "react";
import { LogoWhite } from "assets";

import { Button } from "../../Atoms/Button/Button";

export interface IMaintenancePageTexts {
  logoLabel: string;
  headerText: string;
  messageText: string;
  statusLinkText: string;
}

export interface IMaintenancePageProps {
  texts: IMaintenancePageTexts;
  statusPageLink?: string;
}

export const MaintenancePage: React.FC<
  React.PropsWithChildren<IMaintenancePageProps>
> = ({ texts, statusPageLink = "https://status.spotlight.com/" }) => {
  return (
    <div className="bg-grey-ink-0 h-screen w-full overflow-y-auto p-3 md:p-0">
      <div
        aria-label={texts.logoLabel}
        className="mx-auto my-12 w-80"
        role="img"
      >
        <LogoWhite />
      </div>
      <h1 className="font-secondary mt-2.5 text-center text-7xl text-white">
        {texts.headerText}
      </h1>
      <div className="font-primary mx-auto mt-2.5 max-w-screen-sm px-5 text-center text-xl text-white">
        {texts.messageText}
      </div>
      <div className="mt-7 flex">
        <Button
          type="primary"
          className="w-full sm:mx-auto sm:w-auto"
          href={statusPageLink}
          text={texts.statusLinkText}
        />
      </div>
    </div>
  );
};
